import React, {ReactNode} from "react";
import {Tab} from "@headlessui/react";

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}
export interface TabsProps {
  contents: [{tab: ReactNode; body: ReactNode | null}];
  active: number;
  theme: string;
}

export const Tabs = ({
  contents,
  active = 0,
  theme = "falabella",
}: TabsProps) => {
  return (
    <div className={`sm:px-0 theme-${theme}`}>
      <Tab.Group defaultIndex={active}>
        <Tab.List className="flex space-x-1">
          {contents.map((title, idx) => (
            <Tab
              key={idx}
              className={({selected}) =>
                classNames(
                  "w-1/2 text-sm font-medium leading-5",
                  selected
                    ? "border-b-4 border-primary"
                    : "hover:text-secondary"
                )
              }
            >
              {title.tab}
            </Tab>
          ))}
        </Tab.List>
        <Tab.Panels>
          {contents.map((content, idx) => (
            <Tab.Panel key={idx}>{content.body}</Tab.Panel>
          ))}
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
};
